import React, { useCallback, useMemo } from 'react';
// eslint-disable-next-line
import { Typography } from '@mui/material';
import EDDialog from '../../BaseComponents/Dialog/EDDialog';
import { IDialogFooterActionButton } from '../../BaseComponents/Dialog/DialogFooter/EDDialogFooter';

interface IProps {
  open: boolean;
  backendVersion?: string;
  frontendVersion?: string;
}

const reloadHard = () => {
  // Hard reload bypassing cache if possible
  if (window.location && window.location.reload) {
    window.location.reload();
  }
};

export const VersionMismatchModal: React.FC<IProps> = (props: IProps) => {
  const handleReload = useCallback(() => reloadHard(), []);

  const footerActions: IDialogFooterActionButton[] = useMemo(
    () => [
      {
        label: 'Ladda om nu',
        onClick: handleReload,
        buttonProps: { primary: true },
      },
    ],
    [handleReload]
  );

  return (
    <EDDialog
      open={props.open}
      title="Ny version av Aveny finns"
      disableEscapeKeyDown
      noCloseIcon
      fullWidth
      maxWidth="sm"
      footerActions={footerActions}
      disableDrag
    >
      <Typography gutterBottom>
        Din webbläsare använder en äldre version av gränssnittet ({props.frontendVersion ?? 'okänd'}) än servern ({props.backendVersion ?? 'okänd'}).
      </Typography>
      <Typography gutterBottom>
        För att fortsätta måste sidan laddas om så att den senaste versionen hämtas. Detta fönster kan inte stängas.
      </Typography>
    </EDDialog>
  );
};

export default VersionMismatchModal;
